module.exports = __webpack_public_path__ + "static/media/YM12_1.f40a259e.jpg";